/** DOM 요소의 크기 얻기 */
export function getElementRect(element: HTMLElement) {
	const rect = element.getBoundingClientRect();
	return {
		height: rect.height >> 0,
		width: rect.width >> 0,
		/** viewport 기준 위치 */
		x: rect.left >> 0,
		y: rect.top >> 0,
	};
}
/** 현재 뷰포트 크기 얻기 */
export function getViewportSize() {
	return {
		height: (window.innerHeight || document.documentElement.clientHeight) >> 0,
		width: (window.innerWidth || document.documentElement.clientWidth) >> 0,
	};
}

type RectStyle = {
	position: 'absolute';
	left: number;
	top: number;
	width: number;
	height: number;
};

export type Axis = 'left' | 'right' | 'top' | 'bottom';

export function rectToStyle(element: HTMLElement): RectStyle {
	const rect = getElementRect(element);

	return {
		height: rect.height,
		left: rect.x,
		position: 'absolute',
		top: rect.y,
		width: rect.width,
	};
}

/**
 * axis default : bottom
 * 기준 요소의 좌표를 기준으로 어느 방향으로 생성할 것인가
 */
export function rectToStyleOffset(element: HTMLElement, offset: number, axis: Axis): RectStyle {
	const rect = rectToStyle(element);

	if (axis === 'left') {
		return {
			height: rect.height,
			left: rect.left - rect.width - offset,
			position: 'absolute',
			top: rect.top,
			width: rect.width,
		};
	}

	if (axis === 'right') {
		return {
			height: rect.height,
			left: rect.left + rect.width + offset,
			position: 'absolute',
			top: rect.top,
			width: rect.width,
		};
	}

	if (axis === 'top') {
		return {
			height: rect.height,
			left: rect.left,
			position: 'absolute',
			top: rect.top - rect.height - offset,
			width: rect.width,
		};
	}

	if (axis === 'bottom')
		return {
			height: rect.height,
			left: rect.left,
			position: 'absolute',
			top: rect.top + rect.height + offset,
			width: rect.width,
		};
	// default : bottom
	return {
		height: rect.height,
		left: rect.left,
		position: 'absolute',
		top: rect.top + rect.height + offset,
		width: rect.width,
	};
}

const xAxis = ['left', 'right'];
const yAxis = ['top', 'bottom'];

const objectKeyClear = (keys: string[], target: Record<string, any>) => {
	for (const key of keys) {
		delete target[key];
	}
};

/** axis default : 해당 축 데이터 지우고 다시 주입 */
export function rectToViewportStyleOffset(before: RectStyle, offset: number, align: Axis) {
	if (xAxis.includes(align)) objectKeyClear(xAxis, before);
	if (yAxis.includes(align)) objectKeyClear(yAxis, before);
	return {
		...before,
		[align]: offset,
	};
}

export type DiagonalAxis =
	| 'topLeft'
	| 'topRight'
	| 'rightTop'
	| 'rightBottom'
	| 'bottomLeft'
	| 'bottomRight'
	| 'leftTop'
	| 'leftBottom';

/** 첫글자로 방향 */
export const prefixDiagonalAxisToAxis = (axis: DiagonalAxis): Axis => {
	if (axis.startsWith('top')) return 'top';
	if (axis.startsWith('bottom')) return 'bottom';
	if (axis.startsWith('left')) return 'left';
	if (axis.startsWith('right')) return 'right';
	return 'bottom';
};

export const diagonalAxisArray: DiagonalAxis[] = [
	'topLeft',
	'topRight',
	'rightTop',
	'rightBottom',
	'bottomLeft',
	'bottomRight',
	'leftTop',
	'leftBottom',
];

export const axisArray: Axis[] = ['left', 'right', 'top', 'bottom'];
